import script from "./IndiceAgresividad.vue?vue&type=script&setup=true&lang=js"
export * from "./IndiceAgresividad.vue?vue&type=script&setup=true&lang=js"

import "./IndiceAgresividad.vue?vue&type=style&index=0&id=922ae6e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-922ae6e8"]])

export default __exports__